const LABELS = {
  register: 'Tender register',
  knowledge: 'Knowledge bank',
  credentials: 'Credentials',
  projects: 'Projects',
  reusable: 'Reusable content',
  personnel: 'Personnel',
  timesheets: 'Timesheets',
  week: 'Weekly entry',
  securities: 'BG / EMD',
  approvals: 'Approvals',
  decide: 'Decision',
  masters: 'Masters',
  upload: 'Upload Center',
  customers: 'Customer',
  services: 'Services',
  sectors: 'Sectors',
  'tender-types': 'Tender types',
  sources: 'Sources',
  'timesheet-activities': 'Timesheet activities',
  issuers: 'Banks and issuers',
  partners: 'Partners',
  'decision-profiles': 'Go / No-Go profiles',
  rates: 'Rates',
  reports: 'Reports',
  support: 'Support',
  'my-work': 'My work',
  settings: 'Settings',
  email: 'Email',
  notifications: 'Notifications',
  timesheet: 'Timesheet rules',
  pursuit: 'Pursuit reminders',
  ai: 'AI',
  dropdowns: 'Dropdown master',
  profile: 'Profile',
  new: 'New',
  edit: 'Edit',
  company: 'Company setup',
  users: 'Users',
  'login-history': 'Login history',
  roles: 'Roles & access',
  applications: 'Applications',
  audit: 'Audit trail',
  'tender-stages': 'Tender stages',
  'tender-priority': 'Priority',
  'tender-urgency': 'Urgency'
};

function isRecordId(part) {
  return /^[a-f0-9]{24}$/i.test(part);
}

function labelFor(part) {
  if (LABELS[part]) return LABELS[part];
  return part
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

function pushCrumb(crumbs, label, to, dynamic) {
  const previous = crumbs[crumbs.length - 1];
  if (previous && previous.to === to && previous.label === label) return;
  crumbs.push({ label, to, dynamic: Boolean(dynamic) });
}

export function buildBreadcrumbTrail(pathname) {
  const path = pathname.split('?')[0].replace(/\/+$/, '') || '/';

  if (path === '/workspace' || path === '/') {
    return [{ label: 'Workspace', to: '/workspace', dynamic: false }];
  }

  if (path === '/apps/tender') {
    return [{ label: 'Overview', to: '/apps/tender', dynamic: false }];
  }

  let root = null;
  let rest = '';

  if (path.startsWith('/apps/tender/')) {
    root = { label: 'Tender Management', to: '/apps/tender', dynamic: false };
    rest = path.slice('/apps/tender/'.length);
  } else if (path.startsWith('/platform/')) {
    root = { label: 'Workspace', to: '/workspace', dynamic: false };
    rest = path.slice('/platform/'.length);
  } else if (path.startsWith('/')) {
    root = { label: 'Workspace', to: '/workspace', dynamic: false };
    rest = path.slice(1);
  }

  if (!root) return [];

  const crumbs = [root];
  const parts = rest.split('/').filter(Boolean);
  let acc = root.to === '/workspace' && path.startsWith('/platform') ? '/platform' : root.to;
  if (path.startsWith('/my-work') || path.startsWith('/profile')) {
    acc = '';
  }

  parts.forEach((part) => {
    acc = `${acc}/${part}`.replace(/\/{2,}/g, '/');
    if (isRecordId(part)) {
      pushCrumb(crumbs, 'Details', acc, true);
      return;
    }
    const known = Object.prototype.hasOwnProperty.call(LABELS, part);
    pushCrumb(crumbs, labelFor(part), acc, part === 'new' || part === 'edit' || !known);
  });

  return crumbs;
}

export function applyBreadcrumbLeaf(crumbs, leaf) {
  const label = typeof leaf === 'string' ? leaf.trim() : '';
  if (!label || !crumbs.length) return crumbs;
  const next = crumbs.map((crumb) => ({ ...crumb }));
  const record = [...next].reverse().find((crumb) => crumb.dynamic && crumb.label === 'Details');
  const target = record || [...next].reverse().find((crumb) => crumb.dynamic);
  if (!target) return next;
  target.label = label;
  target.dynamic = false;
  return next;
}
